<template>
    <div>
        <v-layout row align-center justify-space-between class="header">
            <v-btn flat dark :to="'/bot/' + activeBot.code">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px">{{$t('categoriesReport')}}</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile
                                    v-for="bot in botList"
                                    :key="bot.code"
                                    @click="changeBot(bot)"
                                    :class="activeBot.code === bot.code ? 'active' : ''"
                            >
                                <v-list-tile-title>{{bot.name}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-container fluid grid-list-sm>
            <v-flex xs4 class="pr-2">
                <v-card class="pa-3">
                    <div class="title">
                        {{$t('categoriesReport')}}
                    </div>
                    <CustomPieChart
                            :dataSets="reportData"
                            :labels="reportLabels"
                    ></CustomPieChart>
                </v-card>
            </v-flex>
        </v-container>

        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import ReportService from '@/services/report.service'
import _ from 'lodash'
import BotService from '@/services/bot.service'
import CustomPieChart from '@/components/custom/CustomPieChart'
import ActionTypes from "@/store/ActionTypes";

export default {
        name: 'ReportCategories',
        components: {CustomPieChart},
        data() {
            return {
                loadingDialog: false,
                reportData: [],
                reportLabels: [],
                activeBot: {},
                botList: [],
            }
        },
        mounted() {
            this.loadingDialog = true
            BotService.getAllBot().then(
                result => {
                    this.botList = result.data;
                    let botCode = this.$route.params.botCode
                    if (botCode) {
                        let bot = _.find(this.botList, bot => bot.code === botCode)
                        if (bot) {
                            this.selectBot(bot)
                        } else {
                            this.loadingDialog = false
                            this.$router.push('/report-categories')
                        }
                    } else if (this.botList.length > 0) {
                        this.selectBot(this.botList[0])
                    } else {
                        this.loadingDialog = false
                    }
                },
            ).catch(()=>{
                this.$AppService.handleRequestError('can not get bot list')
            });
        },
        methods: {
            async getData() {
                await ReportService.Categories(this.activeBot.code)
                    .then(result => {
                        let data = result.data;
                        this.reportLabels = _.keys(data);
                        let _reportData = []
                        _.forEach(result.data, function (value, key) {
                            _reportData.push(value)
                        })
                        this.reportData = _reportData
                        this.loadingDialog = false
                    }, () => {
                        this.$AppService.handleRequestError('can not get session info data')
                        this.loadingDialog = false
                    })
            },
            changeBot(bot) {
                this.$store.commit(ActionTypes.BOT, bot)
                this.$router.push('/report-categories/' + bot.code)
            },
            selectBot(bot) {
                this.activeBot = bot
                this.getData()
            },

        },
        watch: {
            '$route'() {
                let botCode = this.$route.params.botCode
                if (botCode) {
                    let bot = _.find(this.botList, bot => bot.code === botCode)
                    if (bot) {
                        this.selectBot(bot)
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .header {
        background: #2a4e69;
        color: #fff;
        padding: 0 15px;
    }

    ::v-deep table.v-table {
        thead th {
            padding: 12px 0 12px 12px;
        }

        tbody tr td {
            white-space: nowrap;
            padding: 12px 0 12px 12px;
        }
    }

    .header-tooltips {
        width: 240px;
        background: #1b3447;
        color: #fff;
        padding: 5px;

        &::v-deep hr {
            border-color: #2a4b64;
        }
    }

    .info-icon {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);;
        caret-color: rgb(73, 119, 238);
    }

    .tooltips-info {
        div:first-child {
            color: #00afc8;
        }
    }

    ::v-deep .v-list .active {
        background: #ccc;
    }

    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }
</style>
